export enum PageName {
  SEARCH = 'page.Hotels.Search',
  INFOSITE = 'page.Hotels.Infosite.Information'
}
